import React from 'react';
import { FlatList as NativeList } from 'react-native';
import { List as KList } from '@ui-kitten/components';
export const Native = NativeList;
export const Kitten = (props) => {
    const { data, ...rest } = props;
    return (<KList data={data} {...rest}/>);
};
export default {
    Native,
    Kitten,
};
//# sourceMappingURL=List.js.map